<template>
    <div class="sidebar">
        <router-link
                class="nav-sidebar-tab"
                title="Server"
                :class="{active: active('settingsServer')}"
                :to="{name: 'settingsServer'}"
        >
            <i class="icon-cog-alt"></i>
        </router-link>

        <router-link
                class="nav-sidebar-tab"
                title="Export"
                :class="{active: active('settingsExport')}"
                :to="{name: 'settingsExport'}"
        >
            <i class="icon-upload"></i>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "SettingsPageMenu",

        props: [
            'current',
        ],

        methods: {
            active(...args) {
                return args.flat().find(page => page === this.current);
            },

        },

    }
</script>

<style>

</style>